import { createPlugin } from '@backstage/core-plugin-api';

import {
  createResourceLinkExtension,
  isResourceName,
} from '@spotify/confidence-core-react';

import { IdentityResourceLink } from './components';

export const eventsPlugin = createPlugin({
  id: 'confidence-iam',
});

export const IdentityResourceLinkExtension = eventsPlugin.provide(
  createResourceLinkExtension({
    id: 'identity-resource-link',
    predicate: ({ name }) => isResourceName(name, 'identities'),
    icon: 'identity',
    render: ({ name, text }) => (
      <IdentityResourceLink name={name} text={text} />
    ),
  }),
);
